export default __webpack_public_path__ + "static/media/hero-bg.71d13569.png";